<template>
  <v-container fluid fill-height justify-center
    align-center>
        <spinner v-if="dataLoading === true" line-fg-color="#28AFAF" size="large"></spinner>
           <v-flex xs12 sm12 md8 lg6 v-else>
            <v-card class="elevation-1">
            <v-toolbar color="primary">
                <v-btn icon class="white--text" @click="goBack">
                <v-icon>arrow_back</v-icon>
                </v-btn>
                <v-toolbar-title class="white--text">Approve Agency</v-toolbar-title>
            </v-toolbar>
            <v-flex>
                <v-data-table
                    v-bind:headers="headers"
                    v-bind:items="forApproval"
                    hide-actions
                    no-data-text="There are no agencies to approve."
                >
                <template slot="items" slot-scope="props">
                    <td>
                        <v-layout justify-center
                            align-center>
                            <v-flex>
                            <v-avatar
                                    :size="avatarSize"
                                    :tile="false"
                                    >
                                    <img :src="props.item.logo_url || defaultLogo" alt="avatar">
                                </v-avatar>
                            </v-flex>
                        </v-layout>
                    </td>
                    <td>{{ props.item.company || "something" }}</td>
                    <td>{{ props.item.email }}</td>
                    <td class="text-xs-center">{{ props.item.approved | booleanify}}</td>
                    <td>
                        <v-layout align-center>
                        <v-flex>
                            <v-btn 
                            @click="approveUser(props.item.id)" 
                            small 
                            dark
                            color="green"
                            >Approve
                            </v-btn>
                        </v-flex>
                        </v-layout>
                    </td>
                </template>
                </v-data-table>
            </v-flex>
            </v-card>
        </v-flex>
        <div row>
          <v-alert
            :color="alert.type"
            icon="check_circle"
            :value="alert.status"
            transition="scale-transition"
          >
            {{ alert.message }}
          </v-alert>
        </div>
  </v-container>
</template>

<script>
import axios from "axios";
import Spinner from "vue-simple-spinner";
import defaultLogo from '../../../assets/placeholder_profile_photo-200x200.png'
export default {
  components: {
    Spinner
  },
  data() {
    return {
      dataLoading: true,
      alert: {
        status: false,
        message: '',
        type: ''
      },
      defaultLogo: defaultLogo,
      pagination: {},
      forApproval: [],
      hide_headers: true,
      headers: [
        {
          text: "Logo",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "Company",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "Email",
          align: "left",
          sortable: false,
          value: "email"
        },
        {
          text: "Approved",
          align: "center",
          sortable: false,
          value: "approved"
        }
      ],
      items: []
    };
  },
  filters: {
    booleanify: function(value) {
      if (value == '0') {
        value = "No";
      } else {
        value = "Yes";
      }
      return value;
    }
  },
  computed: {
    avatarSize() {
      return `40px`;
    }
  },
  methods: {
    alerting(){
      this.alert.status = !this.alert.status;
      setTimeout(() => {
            this.alert.status = !this.alert.status;
        }, 2500);
    },
    goBack(){
      this.$router.push("/admin/agencies");
    },
    approvingCounter() {
      const helperObj = this.items;
      this.forApproval = [];
      for (var k in helperObj) {
        if (helperObj[k].approved === '0') {
          this.forApproval.push(helperObj[k])
        }
      }
    },
    approveUser(id) {
      axios
        .put("/users/" + id, {
          user: {
            approved: "1"
          }
        })
        .then(res => {
          this.getAgencies();
          this.alert.message = 'Agency has been approved.'
          this.alert.type = 'success'
          this.alerting()
        });
    },
    getAgencies() {
      axios
      .get("/agencies")
      .then(response => {
        this.items = response.data.users;
        this.approvingCounter();
        this.dataLoading = false
      });
    }
  },
  mounted() {
    this.getAgencies();
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/Agencies/AgenciesApprove.vue